import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ErrorShell({ code, title, message, action }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-appbg px-6 text-center">
      <p className="font-heading text-7xl font-extrabold text-brand-700">{code}</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">{title}</h1>
      <p className="mt-2 max-w-md text-slate-500">{message}</p>
      <div className="mt-6">{action}</div>
    </div>
  );
}

export function GoHomeButton({ label = "Back to login", to = "/login" }) {
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate(to)} className="rounded-xl bg-brand-700 text-white hover:bg-brand-800" data-testid="error-home-btn">
      {label}
    </Button>
  );
}
